import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader2, AlertCircle } from 'lucide-react';
import { useExperiment } from '../utils/convexHooks';
import { Id } from '../convex/_generated/dataModel';
import { UserProfileButton } from './AuthComponents';
import ThemeToggle from './guided/titration/panels/ThemeToggle';
import StudentProgressViewer from './StudentProgressViewer';

export default function TeacherExperimentStudents() {
    const { id } = useParams<{ id: Id<"experimentConfigs"> }>();
    const navigate = useNavigate();
    const experiment = useExperiment(id);

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
            <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
                <div className="w-full max-w-[1920px] lg:px-8 xl:px-12 mx-auto px-4 sm:px-6 lg:px-8 py-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <button
                                onClick={() => navigate('/teacher/dashboard')}
                                className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors text-gray-500 dark:text-gray-400"
                            >
                                <ArrowLeft className="w-5 h-5" />
                            </button>
                            <div>
                                <h1 className="text-xl font-bold text-gray-900 dark:text-white">
                                    {experiment ? experiment.title : 'Loading...'}
                                </h1>
                                <p className="text-sm text-gray-500 dark:text-gray-400">
                                    Student Roster & Progress
                                </p>
                            </div>
                        </div>
                        <div className="flex items-center gap-4">
                            <ThemeToggle /> <UserProfileButton />
                        </div>
                    </div>
                </div>
            </header>

            <main className="w-full max-w-[1920px] lg:px-8 xl:px-12 mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {experiment === undefined ? (
                    <div className="flex items-center justify-center py-12">
                        <Loader2 className="w-8 h-8 text-indigo-600 animate-spin" />
                    </div>
                ) : experiment === null ? (
                    <div className="text-center py-12">
                        <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
                        <h3 className="text-lg font-medium text-gray-900 dark:text-white">Experiment not found</h3>
                        <p className="text-gray-500 mt-2">The experiment you are looking for does not exist.</p>
                        <button
                            onClick={() => navigate('/teacher/dashboard')}
                            className="mt-6 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
                        >
                            Return to Dashboard
                        </button>
                    </div>
                ) : (
                    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
                        <StudentProgressViewer
                            experimentId={experiment._id}
                            experimentTitle={experiment.title}
                            classCode={experiment.classCode}
                        />
                    </div>
                )}
            </main>
        </div>
    );
}
